import {
  FIRST_FORWARD_ID,
  FIRST_NON_FORWARD_ID,
  SECOND_FORWARD_ID,
  SECOND_NON_FORWARD_ID,
} from 'pages/Valuations/approaches/guidelinePublicCompanies/constants';
import {
  LTM_EBITDA_MULTIPLE_ID,
  LTM_REVENUE_MULTIPLE_ID,
  NTM_EBITDA_MULTIPLE_ID,
  NTM_REVENUE_MULTIPLE_ID,
} from 'pages/ValuationsAllocation/approaches/TransactionComps/config/constants';
import {
  LTM_ADJUSTED_EBITDA,
  LTM_EBITDA,
  LTM_REVENUE,
  NTM_ADJUSTED_EBITDA,
  NTM_EBITDA,
  NTM_REVENUE,
  SPECIFIED_LTM_EBITDA,
  SPECIFIED_LTM_REVENUE,
  SPECIFIED_NTM_EBITDA,
  SPECIFIED_NTM_REVENUE,
} from 'pages/ValuationsAllocation/common/constants/futureExit';

export const METRIC_OPTION_MAP = {
  [LTM_REVENUE]: FIRST_NON_FORWARD_ID,
  [NTM_REVENUE]: FIRST_FORWARD_ID,
  [LTM_EBITDA]: SECOND_NON_FORWARD_ID,
  [NTM_EBITDA]: SECOND_FORWARD_ID,
  [LTM_ADJUSTED_EBITDA]: SECOND_NON_FORWARD_ID,
  [NTM_ADJUSTED_EBITDA]: SECOND_FORWARD_ID,
  [SPECIFIED_LTM_REVENUE]: FIRST_NON_FORWARD_ID,
  [SPECIFIED_NTM_REVENUE]: FIRST_FORWARD_ID,
  [SPECIFIED_LTM_EBITDA]: SECOND_NON_FORWARD_ID,
  [SPECIFIED_NTM_EBITDA]: SECOND_FORWARD_ID,
};

// Transaction Comps (GPT) sheets expose their multiple columns under their own ids
// (e.g. `ltm_revenue_multiple`), not the GPC comparison-column ids above.
export const METRIC_OPTION_MAP_GPT = {
  [LTM_REVENUE]: LTM_REVENUE_MULTIPLE_ID,
  [NTM_REVENUE]: NTM_REVENUE_MULTIPLE_ID,
  [LTM_EBITDA]: LTM_EBITDA_MULTIPLE_ID,
  [NTM_EBITDA]: NTM_EBITDA_MULTIPLE_ID,
  [LTM_ADJUSTED_EBITDA]: LTM_EBITDA_MULTIPLE_ID,
  [NTM_ADJUSTED_EBITDA]: NTM_EBITDA_MULTIPLE_ID,
  [SPECIFIED_LTM_REVENUE]: LTM_REVENUE_MULTIPLE_ID,
  [SPECIFIED_NTM_REVENUE]: NTM_REVENUE_MULTIPLE_ID,
  [SPECIFIED_LTM_EBITDA]: LTM_EBITDA_MULTIPLE_ID,
  [SPECIFIED_NTM_EBITDA]: NTM_EBITDA_MULTIPLE_ID,
};
